<template>
    <div style="background-color:#ffffff;padding-bottom: 52px">
        <introduction-title ch-title="资讯与动态" en-title="NEWS" style="padding-top: 73px"></introduction-title>
        <div class="Information">
            <div class="li"  @click="to_detail(objList.id)">
                <img v-if="objList.listImg" :src="'../../../../static/image/information/'+objList.listImg" class="imgs">
                <img v-else src="@/assets/image/default.png" />
                <div class="title">
                    <div class="txt">{{objList.title}}</div>
                    <div class="time">{{objList.time}}</div>
                </div>
            </div>
            <div class="li">
                <el-tabs type="border-card" style="width: 100%;height: 254px;"  v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="行业资讯" class="tabs" name="1" style="height: 212px;overflow: auto">
                        <div class="card-li" v-for="item in data2" :key="item.id" @click="to_detail(item.id)">
                            <div class="left">
                                <img v-if="item.listImg" :src="'../../../../static/image/information/'+item.listImg">
                                <img v-else src="@/assets/image/default.png" />
                            </div>
                            <div class="right">
                                <div class="titles">{{item.title}}</div>
                                <div class="time">{{item.time}}</div>
                                <div class="subtitle">{{item.subtitle}}</div>
                            </div>
                            <div style="clear:both;"></div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="公司动态" class="tabs" name="2" style="height: 212px;overflow: auto">
                        <div class="card-li" v-for="item in data1" :key="item.id" @click="to_detail(item.id)">
                            <div class="left">
                                <img v-if="item.listImg" :src="'../../../../static/image/information/'+item.listImg">
                                <img v-else src="@/assets/image/default.png" />
                            </div>
                            <div class="right">
                                <div class="titles">{{item.title}}</div>
                                <div class="time">{{item.time}}</div>
                                <div class="subtitle">{{item.subtitle}}</div>
                            </div>
                            <div style="clear:both;"></div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
    </div>

</template>

<script>
    import IntroductionTitle from "@/components/IntroductionTitle.vue";
    export default {
        name: "Information",
        components: {IntroductionTitle},
        data(){
            return{
                data1:[],
                data2:[],
                objList:{},
                activeName:"1"
            }
        },
        mounted() {
            this.data1 =require('@/assets/JSONData/Information/company.json');
            this.data2 =require('@/assets/JSONData/Information/InformationDynamics.json');
            this.objList = this.data2[0]
        },
        methods:{
            handleClick(tab, event){
            if(tab.name==1){
                this.objList = this.data2[0]
            }else {
                this.objList = this.data1[0]
            }
            },
            to_detail(id){
                this.$router.push('/InformationDynamicsDetail?id='+id)
            }
        }
    }
</script>

<style scoped>
    .Information{
        display: flex;
        justify-content: space-between;
        width: 1100px;
        margin-left: 50px
    }
    .Information .li{
        width: 536px;
        height: 254px;
        position: relative;
        cursor: pointer;
    }
    .Information .li .imgs{
        width: 100%;
        height: 100%;
        border-radius: 10px;
    }
    .Information .li .title{
        position: absolute;
        width: 100%;
        bottom: 0;
        height: 88px;
        background: rgba(0, 103, 172, 0.8);
        border-radius: 0px 0px 10px 10px;
        display: flex;
        align-items: center;
    }
    .Information .li .title .txt{
        width: 357px;
        height: 52px;
        font-size: 20px;
        font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
        font-weight: bold;
        color: #FFFFFF;
        text-align: left;
        margin-left: 16px;
    }
    .Information .li .title .time{
        margin-left: 49px;
        font-size: 18px;
        font-family: MicrosoftYaHei;
        color: #FFFFFF;
    }
    .card-li{
        margin-top: 12px;
    }
    .card-li .left{
        width: 200px;
        height: 95px;
        background: #FFFFFF;
        border-radius: 10px;
        float: left;
    }
    .card-li .left img{
        width: 100%;
        height: 100%;
        border-radius: 10px;
    }
    .card-li .right{
        background: #FFFFFF;
        border-radius: 10px;
        text-align: left;
        float: left;
        width: 322px;
        margin-left: 13px;
        height: 95px;
        overflow: hidden;
    }
    .card-li .right .titles{
        font-size: 14px;
        font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
        font-weight: bold;
        color: #363A44;
    }
    .card-li .right .time{
        font-size: 12px;
        font-family: MicrosoftYaHei;
        color: #999999;
        margin-top: 5px;
    }
    .card-li .right .subtitle{
        font-size: 12px;
        font-family: MicrosoftYaHei;
        color: #999999;
        margin-top: 5px;
    }

    ::-webkit-scrollbar {
        width: 0px; /*对垂直流动条有效*/
        height: 2px; /*对水平流动条有效*/
    }

    /*.Information .li*/
</style>
<style>
   .li .el-tabs__nav{
        width: 100% !important;
        border-bottom: 2px solid #0067AC;
    }
   .li .el-tabs__item{
        width: 50% !important;
        border: 0 !important;
        font-size: 16px !important;
        font-family: MicrosoftYaHei !important;
        color: #0067AC !important;
        background: #ffffff;
        height: 41px !important;
    }
   .li .is-active{
        background: #0067AC !important;
        border-radius: 10px 10px 0px 0px !important;
        color: #FFFFFF !important;
    }
   .li .el-tabs--border-card{
        border: 0 !important;
        box-shadow: none !important;
    }

    .el-tabs--border-card>.el-tabs__content{
        padding: 0 !important;
    }

</style>